import { LegalPageLayout } from '@/components/layout/LegalPageLayout';
import { TermsOfServiceContent } from '@/components/legal/TermsOfServiceContent';

export const TermsOfServicePage = () => {
  return (
    <LegalPageLayout
      title="Terms of Service"
      lastUpdated="December 27, 2025"
    >
      <TermsOfServiceContent />
    </LegalPageLayout>
  );
};
